import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=fc5b5f70&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=js&"
export * from "./Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=fc5b5f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../share_webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5b5f70",
  null
  
)

export default component.exports